import { render, staticRenderFns } from "./mzj_LIst.vue?vue&type=template&id=07de981f&scoped=true&"
import script from "./mzj_LIst.vue?vue&type=script&lang=js&"
export * from "./mzj_LIst.vue?vue&type=script&lang=js&"
import style0 from "./mzj_LIst.vue?vue&type=style&index=0&id=07de981f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07de981f",
  null
  
)

export default component.exports